// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1S-gK","containerItemsCenter":"Skeleton_containerItemsCenter__2ykGh"};